export const ScreeningPlugin = {
  install (app, options) {
    const { router, addSidebarItems } = options;

    router.addRoute({
      path: '/screening',
      name: 'screeningRequest',
      component: () => import('./views/screening-request.vue'),
      meta: { layout: 'fullBleed', noAuth: true },
    });

    router.addRoute({
      path: '/screening/:id',
      name: 'screening',
      component: () => import('./views/screening.vue'),
    });

    router.addRoute({
      path: '/screening/list',
      name: 'screeningList',
      component: () => import('./views/screening-list.vue'),
    });

    addSidebarItems([
      {text: 'Screening Requests',  path: '/screening/list', permissions: ['screening.review'] }
    ]);
  }
};
